 import { DashboardHomeComponent } from './dashboards/home/dashboard-home.component';
import { UnAuthorizedAccessComponent } from './account/unauthorized/unauthorizes-access.component';
import { PageNotFound } from './404-error/404-not-found.component';
import { ActivateInventoryComponent } from './shared/activate-inventory/activate-inventory.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './security/utilities/auth.guard';
import { LoginComponent } from './account/login/login.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppLayoutComponent } from './layouts/app/app-layout.component';
import { TempReloadComponent } from './dashboards/temp-reload/temp-reload.component';
import { UnderDevelopmentComponent } from './under-development/under-development.component';
import { InsuredPatientAdmissionRequestComponent } from './adt/admission/insured-patient-admission-request/insured-patient-admission-request.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: '', redirectTo: 'Home', pathMatch: 'full' },
      { path: 'Home', component: DashboardHomeComponent },
      { path: 'Home/Index', component: DashboardHomeComponent },
      { path: 'reload-temp', component: TempReloadComponent },
      { path: 'Doctors', loadChildren: () => import('./doctors/doctors.module').then(m => m.DoctorsModule) },
      { path: 'Patient', loadChildren: () => import('./patients/patients.module').then(m => m.PatientsModule) },
      { path: 'Appointment', loadChildren: () => import('./appointments/appointments.module').then(m => m.AppointmentsModule) },
      { path: 'Billing', loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule) },
      { path: 'Lab', loadChildren: () => import('./labs/labs.module').then(m => m.LabsModule) },
      { path: 'Radiology', loadChildren: () => import('./radiology/radiology.module').then(m => m.RadiologyModule) },
      { path: 'Employee', loadChildren: () => import('./employee/employee.module').then(m => m.EmployeeModule) },
      { path: 'ADT/InsuredPatientAdmissionRequest', component: InsuredPatientAdmissionRequestComponent },
      { path: 'ADTMain', loadChildren: () => import('./adt/adt.module').then(m => m.ADTModule) },
      { path: 'ADT', loadChildren: () => import('./adt/adt.module').then(m => m.ADTModule) },
      { path: 'Settings', loadChildren: () => import('./settings-new/settings.module').then(m => m.SettingsModule) },
      { path: 'Commission', loadChildren: () => import('./commission/commission.module').then(m => m.CommissionModule) },
      { path: 'ReportsWave1', loadChildren: () => import('./reports-wave1/reports.module').then(m => m.ReportsModule) },
      { path: 'Inventory', loadChildren: () => import('./inventory/inventory.module').then(m => m.InventoryModule), data: { currentRoute: 'Inventory' } },
      { path: 'Accounting', loadChildren: () => import('./accounting/accounting.module').then(m => m.AccountingModule) },
      { path: 'accounting', loadChildren: () => import('./accounting/accounting.module').then(m => m.AccountingModule) },
      { path: 'Pharmacy', loadChildren: () => import('./pharmacy/pharmacy.module').then(m => m.PharmacyModule) },
      { path: 'Nursing', loadChildren: () => import('./nursing/nursing.module').then(m => m.NursingModule) },
      { path: 'Scheduling', loadChildren: () => import('./scheduling/scheduling.module').then(m => m.SchedulingModule) },
      { path: 'WardSupply', loadChildren: () => import('./wardsupply/wardsupply.module').then(m => m.WardSupplyModule) },
      {
        path: 'Emergency',
        children: [
          { path: '', component: UnderDevelopmentComponent, pathMatch: 'full' },
          { path: '**', component: UnderDevelopmentComponent }
        ]
      },
      {
        path: 'BloodBank',
        children: [
          { path: '', component: UnderDevelopmentComponent, pathMatch: 'full' },
          { path: '**', component: UnderDevelopmentComponent }
        ]
      },
      { path: 'Medical-records', loadChildren: () => import('./medical-records/medical-records.module').then(m => m.MedicalRecordsModule) },
      { path: 'PayrollMain', loadChildren: () => import('./payroll-module/payroll-main.module').then(m => m.PayrollMainModule) },
      { path: 'Verification', loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule) },
      {
        path: 'OperationTheatre',
        children: [
          { path: '', component: UnderDevelopmentComponent, pathMatch: 'full' },
          { path: '**', component: UnderDevelopmentComponent }
        ]
      },
      { path: 'Dispensary', loadChildren: () => import('./dispensary/dispensary.module').then(m => m.DispensaryModule) },
      { path: 'FixedAssets', loadChildren: () => import('./fixed-asset/fixed-assets.module').then(m => m.FixedAssetsModule), data: { currentRoute: 'FixedAssets' } },
      { path: 'ProcurementMain', loadChildren: () => import('./procurement/procurement.module').then(m => m.ProcurementModule), data: { currentRoute: 'ProcurementMain' } },
      { path: 'ActivateInventory', component: ActivateInventoryComponent },
      { path: 'HRManagment', loadChildren: () => import('./hrmanagment/hrmanagment.module').then(m => m.HRManagmentModule) },
      { path: 'Eligibility', loadChildren: () => import('./Eligibility/eligibility.module').then(m => m.EligibilityModule) },
      { path: 'Preauth', loadChildren: () => import('./preauth/preauth.module').then(m => m.PreauthModule) },
      { path: 'Claims', loadChildren: () => import('./claims/claims.module').then(m => m.ClaimsModule) },
      { path: 'Insurances', loadChildren: () => import('./InsuranceAdministration/insurance-administration.module').then(m => m.InsuranceAdministrationModule) },
      { path: 'under-development', component: UnderDevelopmentComponent },
    ],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  {
    path: 'Account',
    component: AuthLayoutComponent,
    children: [
      { path: 'Login', component: LoginComponent, canActivate: [AuthGuard] },
      { path: 'Unauthorized', component: UnAuthorizedAccessComponent },
    ]
  },
  { path: '**', component: PageNotFound, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled',onSameUrlNavigation: 'reload', initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
